import { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import checkCircularImage from "../../assets/check_circular.png";
import Layout from "../../components/layout/Layout";
import { ClientContext } from "../../state/ClientContext";

const ClientAddSuccessPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { changeSelectedClient } = useContext(ClientContext);

  useEffect(() => {
    if (isLoaded) {
      return;
    }

    if (location.state && location.state.user) {
      setIsLoaded(true);
    }
  }, [isLoaded]);

  return !isLoaded ? null : (
    <Layout showSideNav={false}>
      <div style={{ width: "50%", margin: "auto" }}>
        <img
          src={checkCircularImage}
          alt="Client Add Success"
          style={{ width: "150px", height: "150px" }}
        />
        <h1 style={{ fontSize: "2rem" }}>
          Client added! Now, save their password.
        </h1>
        <p style={{ fontSize: "1.2rem" }}>
          Their password is {location.state.tempPassword}. They’ll need it to
          sign in to their My <br />
          Compass account. They’ve been added to your client list and you can
          now assign them
          <br /> to caregivers.
        </p>
        <button
          className="btn-primary"
          style={{
            color: "#000",
            backgroundColor: "#66A77B",
            padding: "10px 20px",
            fontSize: "1.2rem",
          }}
          onClick={(ev) => {
            ev.preventDefault();
            changeSelectedClient(location.state.user.id);
            navigate(`/client_profile/${location.state.user.id}`, {
              state: {
                tempPassword: location.state.tempPassword,
              },
            });
          }}
        >
          Go to client
        </button>
      </div>
    </Layout>
  );
};

export default ClientAddSuccessPage;
